import React, { createContext, useContext, useState, useEffect } from 'react';

const ColdCallAuthContext = createContext(null);

export function ColdCallAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored auth on mount
    const storedToken = localStorage.getItem('coldcall_token');
    const storedUser = localStorage.getItem('coldcall_user');
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        console.error('Failed to parse stored user:', e);
        localStorage.removeItem('coldcall_token');
        localStorage.removeItem('coldcall_user');
      }
    }
    setLoading(false);
  }, []);

  const login = (tokenValue, userData) => {
    setToken(tokenValue);
    setUser(userData);
    localStorage.setItem('coldcall_token', tokenValue);
    localStorage.setItem('coldcall_user', JSON.stringify(userData));
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem('coldcall_token');
    localStorage.removeItem('coldcall_user');
  };

  const updateUser = (updatedData) => {
    const newUser = { ...user, ...updatedData };
    setUser(newUser);
    localStorage.setItem('coldcall_user', JSON.stringify(newUser));
  };

  return (
    <ColdCallAuthContext.Provider 
      value={{ 
        user, 
        token, 
        loading, 
        isAuthenticated: !!token, 
        login, 
        logout,
        updateUser
      }}
    >
      {children}
    </ColdCallAuthContext.Provider>
  );
}

export function useColdCallAuth() {
  const context = useContext(ColdCallAuthContext);
  if (!context) {
    throw new Error('useColdCallAuth must be used within a ColdCallAuthProvider');
  }
  return context;
}
